import { MinhaAgenda } from '@app/models/minha-agenda';
import { MeAvise } from '@app/models/me-avise';
import { UploadFile } from '@app/components/upload-file/upload-file';
import { ProcessoAnexo } from './processo-anexo.model';

export class ProcessoMovimentacao {

  public Id: number;
  public UsuarioPodeEditar: boolean;
  public ProcessoId: number;
  public TipoMovimentacaoId: TipoMovimentacao;
  public Data: string;
  public Descricao: string;
  public Destaque: boolean;
  public Fixado: boolean;
  public Resumo: boolean;
  public Aberto: boolean;
  public Sigiloso: boolean;
  public UsuarioAdvogadoDoProcesso: boolean;
  public PermissaoAcessarSigilo: boolean;

  public NumeroBeneficio: string;
  public UsuarioCriacaoId: number;
  public UsuarioCriacao: string;
  // public AtoProcessualId: number;
  // public AtoProcessual: string;

  public MeAvise: Array<MeAvise>;
  public Prazo: Array<MeAvise>;
  public Audiencia: Array<MinhaAgenda>;
  public Agenda: Array<MinhaAgenda>;

  public ValidarAvisos: boolean;

  public TotalMeAvisePendentes: number;
  public TotalMeAviseRealizados: number;
  public VerRealizados: boolean;
  public VerAgendamentos: boolean;

  public NumeroInstancia: string;

  public Arquivos: Array<UploadFile>;
  public Documentos: Array<ProcessoAnexo>;

  public Anexo: Array<ProcessoAnexo>;

  public Ativo: boolean;

  public PublicacaoId?: number;
  public ProcessoArquivado: boolean;

  constructor() {
    this.Id = 0;
    this.MeAvise = [];
    this.Prazo = [];
    this.Audiencia = [];
    this.Agenda = [];
    this.Descricao = '';
    this.TipoMovimentacaoId = 3;
    this.Arquivos = [];
    this.Anexo = [];
    this.NumeroInstancia = '';
    this.Aberto = false;
  }
}

export enum TipoMovimentacao {
  ADMINISTRATIVA = 1,
  EXECUCAO_PROVISORIA = 2,
  JUDICIAL = 3,
  ATO_PROCESSUAL = 4,
}
